angular.module('jv.search.next-workflow.service', [])
.service('jvNextWorkflow', [
    '$http',
    function($http) {
        this.get = function(applicationEId) {
            var url = jvUrls.jhire + '/action/application/' + applicationEId + '/workflowActions';
            return $http.get(url).then(function(response) {
                return response.data.applicationWorkflowActions || [];
            });
        }
    }
]);